export enum UsageMeterType {
  AI = 1,
  BizzMineCredits = 2
}
